<script>
    import Header from "./components/Header.svelte";
    import Footer from "./components/Footer.svelte";
    import Router, {querystring} from "svelte-spa-router";
    import routes from "./js/routes"
    import ShoppingCart from "./components/cart/ShoppingCart.svelte";
    import {showDialogLogin, showShoppingCart} from "./js/stores";
    import {location} from 'svelte-spa-router'
    import Brands from "./components/Brands.svelte";
    import ShutdownScreen from "./components/ShutdownScreen.svelte";
    import DialogLogin from "./components/modals/DialogLogin.svelte";
    import {onMount} from "svelte";
    import {API_URL} from "../env";
    import Notifications from "./components/notifications/Notifications.svelte";

    let dateNow = new Date()

    let dateBanner = new Date("2999-02-13") // Začátek horního banneru
    let dateShutdown = new Date("3000-02-17") // Začátek Shutdown celého webu
    let dateEndShutdown = new Date("2023-07-20") // Konec Shutdown celého webu a banneru

    let bannerText = "" // <b>DOVOLENKA!</b> Objednávky vytvorené od 15.2.2024 budú vybavené a odoslané 18.2.2024. Ďakujeme za pochopenie.
    let shutdownText = '<h3>Medzi 23.12.2022 - 1.1.2023 čerpáme dovolenku.</h3><h3>E-shop bude znovu funkčný 2.1.2023. Ďakujeme za pochopenie.</h3>'

    async function checkBanner() {
        const res = await fetch(API_URL+'/pages/banner');
        const banner = await res.json();

        if(banner.any){
            dateBanner = new Date(banner.datetime_start);
            bannerText = banner.text;
            dateEndShutdown = new Date(banner.datetime_end);
        }
    }

    checkBanner();

    onMount(() => {
        const urlParams = new URLSearchParams($querystring)

        if (urlParams.has("m")) {
            let modal = urlParams.get("m")

            if (modal === "prihlasit-sa") {
                showDialogLogin.set({show: true, type: "login", data: {}})
            }
            else if (modal === "obnoveni-hesla") {
                showDialogLogin.set({show: true, type: "changeForgottenPassword", data: {}})
            }
            else if (modal === "overenie-uctu") {
                showDialogLogin.set({show: true, type: "accountActivation", data: {}})
            }
        }
    })
</script>

{#if dateNow > dateShutdown && dateNow < dateEndShutdown}

    <ShutdownScreen
            text={shutdownText}
    />

{:else}

    <Notifications/>

    <Header
        bannerText="{(dateNow > dateBanner && dateNow < dateShutdown)? bannerText : ''}"
    />

    <main>
        <Router {routes}/>
    </main>

    <Brands/>

    <Footer/>

    {#if $showShoppingCart && ( $location.toString() !== "/suhrn" || $location.toString() !== "/dodacie-udaje" || $location.toString() !== "/dokoncenie")}
        <ShoppingCart/>
    {/if}

    {#if $showDialogLogin.show}
        <DialogLogin/>
    {/if}

{/if}

